import React, { useRef, useEffect } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { history } from "redux/configureStore";
import { setAssetClass } from "pages/redesign/menuFilterBar/api/setAssetClass";
import { _t, isEn } from "app/i18n/i18n";
import { ContentCompanyLogoNew } from "app/header/ContentCompanyLogoNew/ContentCompanyLogoNew";
import { getActiveAssetClassFromUrl } from "../../../publications/api/searchRequest/urlHelpers";
import NomuraMountainsSvg from "../../images/nomuraMountains.svg";
import nomuraLogoSvg from "../../images/nomuraLogo.svg";
import "./DesktopHeaderParts.scss";

export const ASSET_CLASSES = ["Home", "Economics", "Equity", "FX", "Rates", "SP/Credit", "Macro Strategy", "Quants"];

export function AssetClassBar() {
  return (
    <section className="headerBar bg-white d-flex align-items-center">
      <Navbar.Brand title={_t("Home")} onClick={goHome} className="p-0 m-0 d-none d-lg-block bg-white">
        <NomuraLogo />
        <NomuraMountains />
      </Navbar.Brand>
      <MainNavBar />
      <ContentCompanyLogoNew />
    </section>
  );
}

export function NomuraLogo() {
  return (
    <img
      src={nomuraLogoSvg}
      className="nomuraLogo fill-red cursor-pointer"
      onClick={() => history.push("/Home")}
      alt="Nomura logo"
    />
  );
}

export function NomuraMountains() {
  return <img src={NomuraMountainsSvg} className="nomuraMountains" alt="Nomura logo" />;
}

export function NavItem({ asset, displayNew = false }) {
  const navRef = useRef(asset);
  const activeAsset = getActiveAsset();
  const hrefAsset = asset === "SP/Credit" ? "SP__Credit" : asset;

  useEffect(() => {
    if (activeAsset === asset) {
      navRef.current.classList.add("active");
    } else {
      navRef.current.classList.remove("active");
    }
  }, [activeAsset, asset]);

  return (
    <div className="nav-item-container">
      <Nav.Link
        name={asset}
        ref={navRef}
        className="asset-link"
        href={`${window.location.origin}/research/m/${hrefAsset}`}
        onClick={(event) => {
          setAssetClass(event, asset);
        }}
      >
        {_t(asset)}
      </Nav.Link>
      {displayNew && <NewIcon className="nav-item-new-icon" />}
    </div>
  );
}

const getActiveAsset = () => {
  const assetClassFromUrl = getActiveAssetClassFromUrl();
  return assetClassFromUrl === "SP__Credit" ? "SP/Credit" : assetClassFromUrl;
};

export function AssetClasses() {
  return ASSET_CLASSES.map((asset) => <NavItem key={asset} asset={asset} />);
}

function EventsNavItem() {
  const EVENTS_PATH = "Events";
  return <NavItem key={EVENTS_PATH} asset={EVENTS_PATH} />;
}

export function NewIcon({ className, style }) {
  return (
    <span className={`new-icon ${className}`} style={style}>
      New!
    </span>
  );
}

export function MainNavBar() {
  return (
    <Nav className="menuItems flex-nowrap">
      <AssetClasses />
      {isEn() && <EventsNavItem />}
    </Nav>
  );
}

const goHome = () => {
  history.push("/Home");
  return false;
};
